const { mediaQuery } = require('../helpers');

let prevScrollPos = window.scrollY;

window.addEventListener('scroll', function () {
	const header = document.querySelector('#site-header');
	if (window.scrollY > 80) {
		header.classList.add('is-sticky');
	} else {
		header.classList.remove('is-sticky');
	}

	if (mediaQuery('xl')) {
		return;
	}

	const currentScrollPos = window.scrollY;

	if (prevScrollPos > currentScrollPos) {
		// user has scrolled up
		header.classList.add('show');
	} else if (window.scrollY > 80) {
		// user has scrolled down
		header.classList.remove('show');
	}

	prevScrollPos = currentScrollPos;
});
